export const EMAIL_NEW_LINE = '%0D%0A';
